
<template>
  <!-- 护理记录表 一个人一个月的数据 -->
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form :inline="true" :model="filteForm" class="demo-form-inline toolbar" style="padding-bottom: 0px"
        @submit.native.prevent>
        <el-form-item label="月份">
          <el-date-picker
            v-model="filteForm.dayStr"
            :clearable="false"
            type="month"
            value-format="yyyy-MM"
            placeholder="请选择月份"
          />
        </el-form-item>
        <el-form-item label="老人姓名">
          <el-autocomplete
              v-model.trim="filteForm.oldName"
              auto-complete="off"
              placeholder="请选择老人"
              :fetch-suggestions="queryOlder"
              @select="SelectOlder"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" plain @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" plain class="el-icon-plus" @click="showAddForm">新增</el-button>
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <el-table :data="dataList" style="width: 100%" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor">
          <el-table-column label="日期" align="center" prop="dayStr" />
          <el-table-column v-for="(item,index) in carePj" :key="item.id" :label="item.dictName" 
            align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span :style="[{color:scope.row.child[index].num != 0 ? 'red' : 'gray'},
              {'font-size':scope.row.child[index].num != 0 ? '20px' : '14px'}]">{{scope.row.child[index].num}}次</span>
            </template>
          </el-table-column>
          <el-table-column label="签名" align="center" min-width="90" prop="nursing" />
          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button type="waring" size="mini" plain @click="handleDetail(scope.$index, scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 弹出新增 -->
      <el-dialog title="新增护理记录" 
        :visible.sync="dialogFormVisible" 
        :close-on-click-modal="false"
        :close-on-press-escape="false" 
        class="dangerbuttonxz" 
        @close="closeDialog">
        <el-form ref="form" :model="addForm">
          <el-row>
            <el-form-item 
              label="老人姓名" 
              :label-width="formLabelWidth"
              prop="oldName">
              <el-autocomplete
                  v-model.trim="addForm.oldName"
                  auto-complete="off"
                  placeholder="请选择老人"
                  class="commonwidth"
                  :fetch-suggestions="queryOlder"
                  @select="SelectOld"
              ></el-autocomplete>
            </el-form-item>
            <el-form-item 
              label="服务项目" 
              :label-width="formLabelWidth"
              prop="careList">
              <el-select v-model="addForm.careList" 
              class="commonwidth" multiple placeholder="请选择">
                <el-option
                  v-for="item in carePj"
                  :key="item.id"
                  :label="item.dictName"
                  :value="item.dictName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="护理员:"
              :label-width="formLabelWidth"
              prop="userName"
            >
              <el-autocomplete
                v-model.trim="addForm.userName"
                auto-complete="off"
                placeholder="请输入护理员"
                class="commonwidth"
                :fetch-suggestions="querynurse"
                @select="SelectUser"
              ></el-autocomplete>
            </el-form-item>
            <el-form-item label="日期" :label-width="formLabelWidth" prop="dayStr">
              <el-date-picker
                v-model="addForm.dayStr"
                type="date"
                placeholde="今天"
                class="commonwidth"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </el-form-item>
            <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
              <el-input v-model.trim="addForm.remark" class="commonwidth" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="submitForm('addForm')" :loading="addLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 弹出新增 -->
      <el-dialog title="查看护理记录" 
        :visible.sync="dialogShowVisible" 
        :close-on-click-modal="false"
        :close-on-press-escape="false" 
        center
        style="60%">
        <el-table :data="dialogList" style="width: 100%" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor">
          <el-table-column label="日期" align="center" prop="dayStr" />
          <el-table-column label="项目" align="center" prop="carePj" />
          <el-table-column label="老人" align="center" prop="oldName" />
          <el-table-column label="护理员" align="center" prop="nursing" />
          <el-table-column label="时间" align="center" prop="createdTime" />
          <el-table-column label="备注" align="center" prop="remark" />
        </el-table>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button type="primary" @click="dialogShowVisible = false">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import util from "@/utils/util.js";
export default {
  name: "TableCareProject",
  data() {
    return {
      today:"",
      addForm: {},
      filteForm: {
        dayStr: "",
        oldId:"",
        oldName:"",
      },
      carePj:[],
      dataList: [],
      currentPage: 1,
      addLoading:false,
      totalDataNumber: 0,
      pageNum: 1,
      formLabelWidth: '120px',
      loading: false,
      dialogShowVisible: false,
      dialogList:[],
      dialogFormVisible: false
    };
  },
  methods: {
    //点击查询
    onSubmit() {
      if (this.filteForm.dayStr == "" || this.filteForm.oldName == '') {
        this.$message({
          type: "error",
          message: "请选择老人",
        });
      } else {
        this.getTableData();
      }
    },
    showAddForm(){
      this.addForm = {};
      this.dialogFormVisible = true;
    },
    /* 
    模糊查询老人
    */
    queryOlder(queryString, cb) {
      let param = {
        oldName: queryString
      };
      this.$postJson("omc/Oldman/quickShowAllOldMan", param).then((res) => {
        this.oldmanList = res.result.list;
        var list = [];
        if (res.result.list.length > 0) {
          for (let i of res.result.list) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
          setTimeout(() => {
            this.dataForm.oldName = "";
          }, 1000);
        }
      });
    },
    SelectOld(item){
      this.addForm.oldId = item.oldmanId;
      this.addForm.oldName = item.oldName;
    },
    /* 
      根据负责人获取负责人id
    */
    SelectOlder(item) {
      this.filteForm.oldId = item.oldmanId;
      this.filteForm.oldName = item.oldName;
    },
    /* 
    模糊查询负责人
   */
   querynurse(queryString, cb) {
      let param = {
        userName: queryString
      };
      this.$postJson("uac/emp/queryEmpListWithPage", param).then((res) => {
        this.nurseList = res.result.list;
        var list = [];
        if (res.result.list) {
          for (let i of res.result.list) {
            i.value = i.userName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
        }
      });
    },
    /* 
      根据负责人获取负责人id
    */
    SelectUser(item) {
      this.addForm.nursing = item.userName;
    },
    closeDialog() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },
    handleDetail(index,row){
      this.dialogShowVisible = true;
      this.dialogList = row.tableCarePjBeanList;
    },
    //删除
    handleDelete(index, row) {
      if (row.bind == false) {
        this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          closeOnClickModal: false,
        }).then(() => {
          let id = row.id;
          console.log(id);
          this.$postJson("dmc/table/deleteCare/" + id).then((res) => {
            if (res.code == 200) {
              console.log(res);
              this.$message({
                type: "success",
                message: res.message,
              });
              this.getTableData();
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          });
        })
      }
    },
    // 新增弹出框点击确定提交信息
    submitForm(datainfo) {
      this.addLoading = true;
      let param = this.addForm;
      this.addForm.careList.forEach(item=>{
        param.carePj = item;
        this.$postJson(
          "omc/table/saveCarePj",
          param
        ).then(res=>{
          if (res.code != "200") {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
      })
      setTimeout(_=>{
        this.addLoading = false;
        this.dialogFormVisible = false;
        this.$refs.form.resetFields(); //移除校验结果并重置字段值
        this.getTableData();
      },500)
    },
    //获取分页的紧急按钮数据  只获取pageSize条数据
    getTableData() {
      let param = {
        dayStr: this.filteForm.dayStr,
        oldId:this.filteForm.oldId
      };
      if(param.oldId == null || param.oldId == ''){
        return;
      }
      console.log(param);
      this.loading = true;
      this.$postJson("omc/table/selectCareByMonthAndOld", param).then(
        (res) => {
          console.log(res);
          //判断是否有数据
          if (res.result.length != 0) {
            this.resolveList(res.result)
            setTimeout(() => {
              this.loading = false;
            }, 200);
          } else {
            this.dataList = [];
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          }
        }
      );
    },
    resolveList(list){
      list.forEach(item=>{
        item.dayStr = item.day.substring(8,10)
        item.child = [];
        this.carePj.forEach(item2=>{
          //
          item.child.push({
            carePj:item2.dictName,
            num:0
          })
        })
        item.tableCarePjBeanList.forEach(item3=>{
          item3.createdTime = item3.createdTime.substring(10,16)
          item.nursing = item3.nursing;
          item.child.forEach(item4=>{
            if(item4.carePj == item3.carePj){
              item4.num = Number(item4.num)+1;
            }
          })
        })
      })
      this.dataList = list;
    },
    getCarePj(){
      this.$postJson("mdc/dict/queryDictSubListByDictCode/carePj").then(
        (res) => {
          console.log(res);
          //判断是否有数据
          if (res.result.length != 0) {
            this.carePj = res.result;
          } else {
            this.carePj = [];
          }
        }
      );
    },
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      return "background-color: #ffffff";
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 14px;background-color: #d4f5fa;";
      }
    },
  },
  created() {
    this.getCarePj();
    //获取月份
    const nowDate = new Date();
    this.today = util.formatDate.format(new Date())
    const date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
    };
    this.filteForm.dayStr = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month);
  },
  mounted() {
    this.getTableData();
  },
};
</script>
<style lang="scss" scoped>
.buttonlist {
  .buttonlist-m {
    padding: 10px 0 0 5px;
  }
}

.fenye {
  margin: 0;
  padding: 20px 0;
  background: #fff;
}

::v-deep .dangerbuttonxz .el-dialog {
  width: 500px !important;
}
.commonwidth{
  width: 260px;
}

</style>